import useQuery from "../routes/helper/useQueryHooks"
import styled from "styled-components"
import { Typography } from "../Components/Typography"
import history from "../routes/helper/history"
import CONSTANTS from "../constants"
const Container = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
padding: 10% 10%;
`
const Button = styled.button`
  padding: 10px;
  height: 50px;
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.primary ? "palevioletred" : "#9b59b6")};
  cursor: ${(props) => (props.loading ? "progress" : "pointer")} !important;
  color: #fff;
  margin: 20px;
  font-weight: bold;
`
export default () => {
  return <>
    <Container>
    <Typography fontSize="1.4">O servidor está indisponivel no momento</Typography>
    <Typography fontSize="1 "className="text-muted">Tente novamente mais tarde</Typography>
    <Typography> codigo: 500 | Service Unavailable</Typography>
    <div>
      <br/>
      <br/>
      <Button onClick={() => history.push(CONSTANTS.APP.LOGIN)}>Pagina Inicial</Button>
      <Button onClick={history.goBack}>Voltar a pagina anterior</Button>
    </div>
    </Container>
  </>
}